import React from "react";
export function Footer() {
  return <footer className="bg-ink px-4 pb-32 pt-12 text-center text-white/60 sm:pb-36" data-id="element-208" data-mp="19ivlq3plplne">
      <div className="mx-auto max-w-3xl" data-id="element-209" data-mp="206rhbd2wfkqn">
        <p className="font-serif text-xl font-bold text-white" data-id="element-210" data-mp="2f4tm1qlo2c9h">Mastopexy Surgical Blueprint™</p>
        <p className="mt-2 text-sm" data-id="element-211" data-mp="2f2h6fk3dsdzl">© 2026 Dr. Michael Carter. All rights reserved.</p>
        <p className="mt-1 text-sm font-semibold text-goldlight" data-id="element-212" data-mp="2a3nqll0mgaw9">Educational material intended for qualified medical professionals.</p>
        <p className="mt-6 text-xs leading-relaxed" data-id="element-213" data-mp="1hhl6sdc9dzfx">
          Mastopexy Surgical Blueprint™ is intended for professional education and case-based learning. It is not a
          substitute for formal surgical training, supervision, clinical guidelines, institutional protocols,
          individualized patient evaluation or professional clinical judgment. Surgical techniques, indications and
          outcomes vary. Healthcare professionals are responsible for applying current evidence, applicable regulations
          and appropriate clinical judgment to each individual patient.
        </p>
      </div>
    </footer>;
}